var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.944 9.973a.59.59 0 0 0 0 .83c.23.224.613.224.837 0L6 6.584l4.219 4.22c.224.223.613.23.837 0a.597.597 0 0 0 0-.831L6.837 5.747l4.219-4.218a.59.59 0 0 0 0-.831.593.593 0 0 0-.837 0L6 4.917 1.781.698a.587.587 0 0 0-.837 0 .597.597 0 0 0 0 .83l4.219 4.22z"
  })));
};
export default SvgClose;